import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Searcher from "../../../searcher/index.js";
import { SearcherItem } from "../../../searcher/styled.js";
import SearcherActivitiesButton from "../../components/button/index.js";
import SearcherActivitiesCalendarInput from "../../components/calendar-input/index.js";
import SearcherActivitiesDestinationInput from "../../components/destination-input/index.js";
import SearcherActivitiesPassengersInput from "../../components/passengers-input/index.js";
import SearcherActivitiesForm from "../../components/searcher-form/index.js";
const SearcherActivitiesMobileView = ()=>/*#__PURE__*/ _jsxs(Searcher, {
        "data-testid": "SearcherActivities",
        children: [
            /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherActivitiesDestinationInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherActivitiesCalendarInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherActivitiesPassengersInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherActivitiesButton, {})
        ]
    });
const SearcherActivitiesMobile = (props)=>/*#__PURE__*/ _jsx(SearcherActivitiesForm, {
        ...props,
        children: /*#__PURE__*/ _jsx(SearcherActivitiesMobileView, {})
    });
export default SearcherActivitiesMobile;

//# sourceMappingURL=index.js.map